import { useCapabilities } from '@office-start/capabilities-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useEffect } from 'react';
import { useEdgeworthLocalDocumentsStore } from '../store/useEdgeworthLocalDocumentsStore';
export function useEdgeworthLocalDocuments() {
    var context = useOfficeComponentContext().data;
    var capabilities = useCapabilities().data;
    var _a = useEdgeworthLocalDocumentsStore(), localDocuments = _a.localDocuments, setLocalDocuments = _a.setLocalDocuments;
    useEffect(function () {
        if (!context ||
            !capabilities ||
            context.workload !== 'pwa' ||
            !capabilities.isPwaInUwp ||
            !!localDocuments // don't fetch more than once
        ) {
            return;
        }
        import('@office-start/hwa-native-bridge-service')
            .then(function (mod) { return mod.getLocalMru(); })
            .then(function (docs) {
            setLocalDocuments(docs || []);
        });
    }, [context, capabilities, localDocuments, setLocalDocuments]);
    return localDocuments || [];
}
//# sourceMappingURL=useEdgeworthLocalDocuments.js.map